/**
 * Converts number to a string with a comma as a thousand separators
 *
 * @todo Rename to `formatNumber` or anything else starting with a verb
 */
export function numberToDelimited(number: number, delimiter = ',') {
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + delimiter)
}
